(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rvertv-faq"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function (e) {
    var header = e.target.closest('[data-rv-faq] .rv-faq-header');
    if (!header) return;
    var block = header.closest('.rv-faq-block');
    var open = block.classList.toggle('rv-active');
    header.setAttribute('aria-expanded', open ? 'true' : 'false');
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rvertv-gadgets"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      if (!root || root.dataset.rvInit) return;
      root.dataset.rvInit = '1';

      var cards = Array.prototype.slice.call(root.querySelectorAll('[data-rv-card]'));
      var filterWrap = root.querySelector('[data-rv-filters]');
      var searchInput = root.querySelector('[data-rv-search]');
      var empty = root.querySelector('[data-rv-empty]');
      var modal = root.querySelector('[data-rv-modal]');
      var lastTrigger = null;
      var category = 'all';
      var query = '';

      function apply() {
        var shown = 0;
        cards.forEach(function (card) {
          var okCat = category === 'all' || card.dataset.category === category;
          var okQuery = !query || card.dataset.search.indexOf(query) !== -1;
          card.hidden = !(okCat && okQuery);
          if (!card.hidden) shown++;
        });
        if (empty) empty.hidden = shown !== 0;
      }

      if (filterWrap) {
        filterWrap.addEventListener('click', function (e) {
          var btn = e.target.closest('.rv-filter-btn');
          if (!btn) return;
          filterWrap.querySelectorAll('.rv-filter-btn').forEach(function (b) {
            b.classList.remove('rv-active');
          });
          btn.classList.add('rv-active');
          category = btn.dataset.category;
          apply();
        });
      }

      if (searchInput) {
        searchInput.addEventListener('input', function (e) {
          query = e.target.value.toLowerCase().trim();
          apply();
        });
      }

      function openModal(btn) {
        if (!modal) return;
        lastTrigger = btn;
        modal.querySelector('[data-rv-modal-category]').textContent = btn.dataset.categoryLabel || '';
        modal.querySelector('[data-rv-modal-title]').textContent = btn.dataset.title || '';
        modal.querySelector('[data-rv-modal-tip]').textContent = btn.dataset.tip || '';
        modal.querySelector('[data-rv-modal-durability]').textContent = btn.dataset.durability || '';
        var cta = modal.querySelector('[data-rv-modal-cta]');
        if (btn.dataset.ctaUrl) {
          cta.href = btn.dataset.ctaUrl;
          cta.textContent = (btn.dataset.ctaText || '') + ' ↗';
          cta.hidden = false;
        } else {
          cta.hidden = true;
        }
        modal.classList.add('rv-active');
        modal.querySelector('[data-rv-close]').focus();
      }

      function closeModal() {
        if (!modal) return;
        modal.classList.remove('rv-active');
        if (lastTrigger) lastTrigger.focus();
      }

      root.addEventListener('click', function (e) {
        var openBtn = e.target.closest('[data-rv-open]');
        if (openBtn) {
          openModal(openBtn);
          return;
        }
        if (e.target.closest('[data-rv-close]') || e.target === modal) closeModal();
      });

      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && modal && modal.classList.contains('rv-active')) closeModal();
      });
    }

    function initAll() {
      document.querySelectorAll('[data-rv-gadgets]').forEach(init);
    }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
    else initAll();

    document.addEventListener('shopify:section:load', function (e) {
      var el = e.target.querySelector('[data-rv-gadgets]');
      if (el) init(el);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
